import React from "react";
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";

import ArticleGrid from "../ArticleGrid";
import InfoGrid from "../InfoGrid";
import TitleBar from "../TitleBar";
import SocialBar from "../SocialBar";
import ArticleCard from "../ArticleCard";

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.tagID = "22934";
    this.state = {
      grid: null,
    };
  }

  componentDidMount() {
    fetch(`https://wp.dailybruin.com/wp-json/wp/v2/tags/${this.tagID}`)
      .then((response) => response.json())
      .then((json) => {
        this.setState({
          title: json.name,
          explainer: json.description,
        });
      });
  }

  jumpToStories() {
    if (document !== undefined) {
      let e = document.getElementById("ArticleGrid");
      let b = document.getElementById("jumpToStoriesButton");
      b.className += " collapse";
      e.scrollIntoView({ behavior: "smooth" });
    }
  }

  render() {
    return (
      <div
        css={css`
          height: 100vh;
          margin: auto;
          position: relative;
          ${globals.phone} {
            height: initial;
          }
        `}
      >
        <div
          css={css`
            width: 50%;
            height: 100%;

            display: inline-block;
            vertical-align: top;
            overflow: scroll;
            padding: 6px;

            ${globals.tablet} {
              width: 66.6%;
            }

            ${globals.phone} {
              width: 100%;
              padding: 6px;
            }
          `}
        >
          <div
            css={css`
              max-width: 624px;
              margin: auto;
            `}
          >
            <div
              css={css`
                padding: 6px;
                position: sticky;
                top: -12px;
                z-index: 100;
              `}
            >
              <TitleBar
                title={this.state.title}
                explainer={this.state.explainer}
              ></TitleBar>
            </div>
            <div
              css={css`
                padding: 6px;
              `}
            >
              <SocialBar></SocialBar>
            </div>
            <InfoGrid info={this.props.info}></InfoGrid>
          </div>
        </div>
        <div
          id="ArticleGrid"
          css={css`
            width: 50%;
            height: 100%;
            overflow: scroll;
            display: inline-block;
            vertical-align: top;
            padding: 6px;
            background-color: #161616;
            position: relative;
            ${globals.tablet} {
              width: 33.3%;
            }
            ${globals.phone} {
              width: 100%;
              padding: 6px;
            }
          `}
        >
          <ArticleGrid tagID={this.tagID}></ArticleGrid>
        </div>
        <div
          id="jumpToStoriesButton"
          onClick={this.jumpToStories}
          css={css`
            font-family: ${globals.menuFont};
            background-color: ${globals.DBblue};
            box-shadow: ${globals.cardShadow};
            font-weight: bold;
            color: #fff;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            height: 40px;
            border: none;
            border-radius: 20px;
            position: fixed;
            bottom: 30px;
            left: 0;
            right: 0;
            margin: 0 auto;
            padding: 10px;
            width: 150px;
            white-space: nowrap;
            cursor: pointer;
            display: none;
            overflow: hidden;
            text-align: center;

            ${globals.phone} {
              display: block;
            }

            &.collapse {
              animation: collapse 300ms cubic-bezier(0.4, 0, 0.2, 1) 0s normal 1;
              animation-fill-mode: forwards;
            }

            @keyframes collapse {
              10% {
                color: ${globals.DBblue};
              }
              100% {
                width: 0;
                padding: 10px 0;
              }
            }
          `}
        >
          JUMP TO STORIES
        </div>
      </div>
    );
  }
}
